import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if already authenticated from sessionStorage
  useEffect(() => {
    const auth = sessionStorage.getItem('ai_doctor_auth');
    if (auth === 'authenticated') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (username === 'innovasense' && password === '2025') {
      sessionStorage.setItem('ai_doctor_auth', 'authenticated');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid credentials');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 9999,
        padding: { xs: 2, sm: 4 }, // Add padding on all sides
      }}
    >
      <Paper
        elevation={24}
        sx={{
          padding: 4,
          backdropFilter: 'blur(20px)',
          backgroundColor: '#174574',
          border: '1px solid #174574',
          borderRadius: 2,
          minWidth: { xs: '90%', sm: 350 },
          maxWidth: 400,
          maxHeight: '90vh', // Prevent touching top/bottom
          overflow: 'auto',
           boxShadow: '0 8px 24px rgba(2, 48, 112, 0.3)',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <LockIcon sx={{ fontSize: 48, color: '#c9d6e1', mb: 2 }} />
          <Typography sx={{ color: '#002f70', fontWeight: 'bold', fontFamily:"Dubai",mb: 1,fontSize:"16pt" }}>
            AI Doctor
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)',fontFamily:"Dubai",fontSize:"14pt" }}>
            Protected Access
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                color: '#fff',
                  fontSize:"14pt",
                fontFamily:"Dubai",
                '& fieldset': {
                  borderColor: '#174574',
                },
                '&:hover fieldset': {
                  borderColor: '#174574',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#174574',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#fff',
              },
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                color: '#fff',
                fontSize:"14pt",
                fontFamily:"Dubai",
                '& fieldset': {
                  borderColor: '#174574',
                },
                '&:hover fieldset': {
                  borderColor: '#174574',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#174574',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#fff'
              },
            }}
          />
          
          {error && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#ff4444', 
                mb: 2, 
                textAlign: 'center' 
              }}
            >
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              background: 'linear-gradient(90deg, #32affc, #1c4778)',
              color: '#fff',
              fontWeight: 'bold',
              fontFamily:"Dubai",
              fontSize:"14pt",
              padding: '12px',
              '&:hover': {
                background: 'linear-gradient(90deg, #1c4778 , #32affc)',
              },
            }}
          >
            Enter
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default PasswordProtection;

